import { useEffect, useState } from 'react';

export default function RunScoredNotification({ runs, teamName }) {
  const [visible, setVisible] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 2500);
    
    return () => clearTimeout(timer);
  }, []);
  
  if (!visible) return null;
  
  return (
    <div className="fixed inset-0 pointer-events-none z-40 flex items-center justify-center">
      <div className="animate-run-scored bg-grass border-8 border-white shadow-2xl px-8 py-6 text-center">
        <p className="retro-heading text-2xl md:text-3xl text-white mb-2">
          {runs > 1 ? `${runs} RUNS` : 'RUN'} SCORED!
        </p>
        <p className="retro-body text-lg text-white/90">
          {teamName}
        </p>
      </div>
    </div>
  );
}
